import { faCalendar, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { filter, cloneDeep } from 'lodash';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import { CoreService } from 'src/app/services/core.service';
import SelfPayType from 'src/app/models/selfPayType';
import SelfPay from 'src/app/models/selfPay';
import * as dayjs from 'dayjs';
import { env } from 'src/env/development';

@Component({
  selector: 'self-pay-dependent-detail',
  templateUrl: 'selfPay.dependent.detail.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayDependentDetailComponent implements OnChanges, OnInit {
  @Input() selfPayDependent!: SelfPayFormDependent;
  @Input() idx!: number;
  @Input() requestType!: SelfPayType;
  @Input() agency!: string;
  @Input() selfPay!: SelfPay;
  @Input() relationshipTypeCode!: string;
  @Input() relationshipQualifyReasonCode!: string;
  @Input() relationshipQualifyReasonId!: string;
  @Input() partnershipStartDate!: Date;
  @Output() submitDependent: EventEmitter<SelfPayFormDependent> = new EventEmitter<SelfPayFormDependent>();
  @Output() closePanel: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('dependentForm') dependentForm: NgForm;
  currentMaxDate: Date;
  noSSN: boolean = false;
  currentDependent: SelfPayFormDependent;
  electMedicalDisabled = false;
  electDentalDisabled = false;
  icons = {
      faCalendar,
      faExclamationCircle
  };
  thirteenYearsDate: Date
  env = env;
  coverageYear: number;
  otherAgency: string;
  genderIdentityDisabled: boolean = false;
  isAdd = true;
  isSpouse = false;

  constructor(private coreService: CoreService){}

  ngOnInit() {
    this.genderIdentityDisabled = this.coreService.getGenderValue();
    this.currentMaxDate = new Date();
    this.thirteenYearsDate = dayjs().subtract(13, 'year').toDate();

    this.currentDependent.surchargeNA = this.selfPay.formJson?.subscriber?.medicarePartBInd && this.selfPay.formJson?.subscriber?.medicarePartAInd;
    this.coverageYear = dayjs(this.selfPay.coverageEffectiveDate ?? new Date()).year();
    this.otherAgency = this.selfPay.isSEBB ? env.pebbCode : env.sebbCode;

    if (this.selfPay.isPEBB && (this.selfPay.isCobraInitial || this.selfPay.isCobraSOE)) {
      if (this.selfPay.formJson.subscriber.medicarePartBInd)
        this.currentDependent.surchargeNA = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selfPayDependent) {
      this.isAdd = !this.selfPayDependent.memberId;
      this.isSpouse = this.selfPayDependent.isSpouse;// ?? this.relationshipTypeCode === 'S';

      this.currentDependent = cloneDeep(this.selfPayDependent);
      this.noSSN = this.currentDependent.socialSecurityNumber?.startsWith('99999');
    }
    
    if (this.selfPay.isRetireeInitial || this.selfPay.isRetireeOE) {
      this.electMedicalDisabled = true;
      this.electDentalDisabled = true;

      if (this.selfPay.isRetireeInitial && this.selfPay.formJson?.subscriber?.actionsCode === 'deferring' &&
          this.selfPay.formJson?.subscriber?.deferQuestionFour) {
          //initial retiree request is deferring due to medicaid, enable dependent coverage for medical only
          this.electMedicalDisabled = false;
          this.electDentalDisabled = true;
      }
    }

    if(this.selfPay){ 
      // if(this.selfPay.formJson?.subscriber?.medicarePartAInd) {
      //   this.currentDependent.memberMedicare.medicarePartAEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartAInd;
      // }
      // if(this.selfPay.formJson?.subscriber?.medicarePartBInd) {
      //   this.currentDependent.memberMedicare.medicarePartBEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartBInd;
      // }
      // if(this.currentDependent.memberMedicare?.medicarePartAEnrolledInd && this.currentDependent.memberMedicare?.medicarePartBEnrolledInd){
      //   // this.currentDependent.surchargeNA = true;  <-- tied to subscriber, not dependent
      //   this.currentDependent.tobaccoUseInd = null;
      // }
 
      if (this.selfPay.formJson.subscriber.medicarePartBInd)
        this.currentDependent.spouseSurchargeTriState = 'N';
    }
  }

  markAllControlsAsTouched(): void {
    this.coreService.markFormControlsAsTouched(this.dependentForm);
  }

  emitSubmitDependent(formContainer) {
    this.markAllControlsAsTouched();
    if (this.dependentForm.valid) {
      this.submitDependent.emit(this.currentDependent);
    } else {
      this.coreService.popMessage('Please complete required fields.', 'error', 4000, this.coreService.getInvalidFields(formContainer));
    }
  }

  cancelChanges() {
    this.currentDependent = cloneDeep(this.selfPayDependent);
    this.closePanel.emit();
  }

  updateTobacco() {
    if (this.currentDependent.surchargeNA) {
      this.currentDependent.tobaccoUseInd = null;
      this.currentDependent.spouseSurchargeTriState = "N";
      this.currentDependent.spouseForm.questionTwoInd = false;
      this.currentDependent.spouseForm.questionThreeInd = false;
      this.currentDependent.spouseForm.questionFourInd = false;
      this.currentDependent.spouseForm.questionFiveInd = false;
      this.currentDependent.spouseForm.questionSixInd = false;
    }
  }

  spousalChange(spouse: SelfPayFormDependent): void {
    if (!(this.selfPay.isPEBB && this.selfPay.isRetireeSOE))
      return;

    if (spouse.spouseAttestQ1 && spouse.spouseAttestQ2 && spouse.spouseAttestQ3 && spouse.spouseAttestQ4 && spouse.spouseAttestQ5 && spouse.spouseAttestQ6)
      this.currentDependent.spouseSurchargeTriState = 'Y';
    else if (spouse.spouseAttestQ1 === false || spouse.spouseAttestQ2 === false || spouse.spouseAttestQ3 === false || spouse.spouseAttestQ4 === false || spouse.spouseAttestQ5 === false || spouse.spouseAttestQ6 === false)
      this.currentDependent.spouseSurchargeTriState = 'N';
  }

  updateCoverageContinue(e, key: string) {
    let bool = (e.target as HTMLInputElement)?.value === 'true';
    if(bool) {
      this.currentDependent[key] = false;
    }else {
      this.currentDependent[key] = true;
    }
  }

  terminateAllCoveragesChange(checked) {
    this.currentDependent.terminateAllCoverageInd = checked;
    this.currentDependent.medicalCoverInd = 
    this.currentDependent.dentalCoverInd =
    this.currentDependent.visionCoverInd = false;
  }

  
  handleMedicalEnrollChange(checked) {
    if(checked) {
       this.currentDependent.terminateAllCoverageInd = false;
      }else if (!checked) {
        
      }
      this.handleCoverageChange(checked);
  }

  updateMedicarePartA(yes: boolean) {
    if(!yes) {
      this.currentDependent.medicarePartADate = null;
      this.currentDependent.medicarePartAInd = false;
    }
    if(yes) {
      this.currentDependent.medicarePartAInd = true;
    }
  }

  updateMedicarePartB(yes: boolean) {
    if(!yes) {
      this.currentDependent.medicarePartBDate = null;
      this.currentDependent.medicarePartBInd = false;
    }
    if(yes) {
      if (!this.selfPay.isSebbCOBRA) this.currentDependent.visionCoverInd = false;
      this.currentDependent.medicarePartBInd = true;
    }
  }

  handleCoverageChange(e) {
    if(e && this.currentDependent.medicalCoverInd) {
      // this.disableFormForNoCoverage = false;
    }else {
      // this.disableFormForNoCoverage = true;
      this.resetFormValues();
    }
  }

  resetFormValues() {
    this.currentDependent.medicarePartAInd =
    this.currentDependent.medicarePartBInd =
    this.currentDependent.spouseSurchargeTriState =
    this.currentDependent.spouseAttestQ1 =
    this.currentDependent.spouseAttestQ2 =
    this.currentDependent.spouseAttestQ3 =
    this.currentDependent.spouseAttestQ4 =
    this.currentDependent.spouseAttestQ5 =
    this.currentDependent.spouseAttestQ6 =
    this.currentDependent.medicareNumber =
    this.currentDependent.medicarePartADate =
    this.currentDependent.medicarePartBDate =
    this.currentDependent.tobaccoUseInd = null
  }

  setCurrentDependentTerminateAll() {
    if (this.currentDependent.terminateAllCoverageDate) {
      this.currentDependent.terminateAllCoverageInd = true;
    }
    else {
      this.currentDependent.terminateAllCoverageInd = false;
    }
  }

  spousalSurchargeLink(selfPay: SelfPay): string | null {
    if (selfPay.isPEBB)
      return 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/spousal-coverage-surcharge';

    if (selfPay.isSebbCobraInitial || selfPay.isSebbLwopInitial)
      return 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/surcharges';

    // Other SEBB...
    return 'https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/spousal-coverage-surcharge';
  }

  spousalRate(coverageYear: number): string {
    if ( coverageYear >= 2027)
      return '140.61';
    
    if (coverageYear == 2026)
      return '137.76';
    
    if (coverageYear == 2025)
      return '126.36';
    
    return '117.81';
  }

  get disableFormForNoCoverage(): boolean {
    const selfPay: SelfPay = this.selfPay;
    const currentDependent: SelfPayFormDependent = this.currentDependent;

    if (selfPay.isRetireeInitial)
      return false;

    if (this.isAdd)
      return selfPay.isRetiree && !currentDependent.medicalCoverInd && !currentDependent.dentalCoverInd && !currentDependent.visionCoverInd;

    return selfPay.isRetiree && !currentDependent.medicalCoverInd;
  }
}
